import * as actionTypes from '../actionTypes'

const startup = (state = {
	isLoading: false,
	isLoaded: false,
}, action) => {
	switch (action.type) {
		case actionTypes.STARTUP_STARTED:
			return {		
				...state,
				isLoaded: false,
				isLoading: true
			}
		case actionTypes.STARTUP_COMPLETED:
			return {
				...state,
				isLoaded: true,
				isLoading: false
			}
		default:
			return state
	}
}

export default startup


// WEBPACK FOOTER //
// ./src/reducers/startup.js